import React from 'react';
import './AdminVoiceScaffold.css';

export default function AdminVoiceScaffold() {
  return (
    <div className="admin-voice-scaffold">
      <header className="admin-voice-header">
        <h1 className="admin-voice-title">Voice — Admin</h1>
        <span className="admin-voice-pill">In build</span>
      </header>
      <p className="admin-voice-subtitle">
        Compliance + audit surface for the inbound voice control plane. Scheduled for slice 2.
      </p>
      <ul className="admin-voice-roadmap">
        <li>Calls log — paginated search by ANI, date range, and auth outcome.</li>
        <li>Per-call drawer — full transcript, recording playback, events timeline, auth attempts.</li>
        <li>Retention sweep — dry-run preview that lists what would delete, then confirmed run.</li>
        <li>Auth failure trends — rejected-pilot count, lockouts, top failing ANIs (last 7d).</li>
      </ul>
      <p className="admin-voice-note">
        For live operator controls today, see <a href="/voice/live">Voice — Live</a>.
      </p>
    </div>
  );
}
